class customAccordion extends HTMLElement {
  constructor() {
    super();

    this.accordionTriggers = this.querySelectorAll('.js-accordion-trigger');

    if (this.accordionTriggers.length > 0) {
      this.accordionTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.toggleType(e));
      });
    }
  }

  toggleType(e) {
    let type = this.getAttribute('data-type');

    if (type === 'only-one') {
      var timer = 0;
      this.accordionTriggers.forEach((trigger) => {
        if (trigger !== e.target) {
          if (trigger.getAttribute('aria-expanded') === 'true') {
            timer = 800;
          }
        }
        if (trigger !== e.target) {
          trigger.setAttribute('aria-expanded', false);
          trigger.nextElementSibling.setAttribute('aria-hidden', true);
        }
      });

      setTimeout(() => {
        this.toggleAccordion(e);
      }, timer);
    } else {
      this.toggleAccordion(e);
    }
  }

  toggleAccordion(e) {
    let accordionBtn = e.target.nodeType === 'BUTTON' ? e.target : e.target.closest('button');
    if (accordionBtn.getAttribute('aria-expanded') === 'false') {
      accordionBtn.setAttribute('aria-expanded', true);
      accordionBtn.nextElementSibling.setAttribute('aria-hidden', false);
    } else {
      accordionBtn.setAttribute('aria-expanded', false);
      accordionBtn.nextElementSibling.setAttribute('aria-hidden', true);
    }
  }
}

customElements.define('custom-accordion', customAccordion);
